//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtSwitch from "~/components/form/MtSwitch";
import SocialLogin from "~/components/forms/SocialLogin";
import RegistrationForm from "~/components/forms/RegistrationForm";
import { handleTouchScroling } from '~/utils/utils';
export default {
  components: {
    MtSwitch,
    SocialLogin,
    RegistrationForm
  },
  data() {
    return {
      mir: false,
      y: 0,
      down: false,
      usedIphone: false
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        ...handleTouchScroling(this, 'registrationWrap')
      }
    }
  },
  mounted() {
    // this.mir = this.$store.getters['forms/getRegistrationWithMir']
    this.mir = false
    this.$store.commit('forms/changeRegistrationWithMir')
    this.usedIphone = navigator.platform.includes('iPhone') || navigator.platform.includes('iPod')
  }
}
